var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongShangchuan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tongyong_shangchuan_svg__clip0_5239_57359)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.328 1.623a.498.498 0 00-.655-.001L4.175 4.62a.5.5 0 10.65.76L7.5 3.087V10a.5.5 0 001 0V3.087l2.675 2.293a.5.5 0 10.65-.76L8.328 1.623zM2 9a.5.5 0 01.5.5v4h11v-4a.5.5 0 011 0v4a1 1 0 01-1 1h-11a1 1 0 01-1-1v-4A.5.5 0 012 9z",
    fill: "#3F465C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tongyong_shangchuan_svg__clip0_5239_57359"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/tongyong_shangchuan.199730e2.svg";
export { SvgTongyongShangchuan as ReactComponent };